var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"vmp-custom-menu-title"},[_c('div',{staticClass:"vmp-custom-menu-title__content"},[_vm._v(_vm._s(_vm.info.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }